import { Box, Button, Divider, Drawer, Flex, Group, Menu, Pagination, Paper, Text } from "@mantine/core"
import LoadingData from "../../../ui/LoadingData"
import { useEffect, useState } from "react"
import { deleteProduct, getAllProductsList, syncGeneralSubProduct, syncPricingSubProduct } from "../../../../services/products"
import TableProductBranch from "./Helper/TableProductBranch"
import NoData from '../../../ui/NoData'
import { modalDeleteData } from "../../../ui/Prompt/modalDeleteData"
import { useDisclosure } from "@mantine/hooks"
import FormSubProduct from "./Form/FormSubProduct"
import { IconExternalLink, IconRefresh } from "@tabler/icons-react"
import { completedLoadingNotification, failedLoadingNotification, loadingNotification } from "../../../ui/Notifications"

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'visibility': true,
  'sort': '-created_at',
  'filter[title][like]': '',
  'include': 'supplier,warehouses',
}

const labelTable = [
  {
    label: 'Id',
    width: 100
  },
  {
    label: 'Product Name',
    width: 350
  },
  {
    label: 'Supplier',
    width: 250
  },
  {
    label: 'Retail Price',
    width: 150
  },
  {
    label: 'Sale Price',
    width: 150
  },
  {
    label: 'Dropship Price',
    width: 150
  },
  {
    label: 'Quantity',
    width: 100
  },
  {
    label: 'Action',
    width: 50
  },
]

const ProductBranch = ({ productId, reloadProduct }) => {
  const [productList, setProductList] = useState([])
  const [loading, setLoading] = useState(false)
  const [totalProduct, setTotalProduct] = useState(0)
  const [paramsProduct, setParamsProduct] = useState({
    ...defaultParams,
    'filter[parent_id][is]': productId,
  })

  // edit sub - product drawer
  const [opened, { open, close }] = useDisclosure(false)
  const [detailData, setDetailData] = useState(null)

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsProduct((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const getList = async () => {
    setLoading(true)
    try {
      const response = await getAllProductsList(paramsProduct)
      if (response.success) {
        const { data, included, meta } = response
        const countData = meta.pagination.total

        const { supplier, warehouses } = included

        const remap = data.map((product) => {
          const { attributes, relationships } = product

          const getSupplier = () => {
            return supplier[relationships?.supplier?.id]?.attributes || null
          }
          const getWarehouse = () => {
            return warehouses[relationships?.warehouses[0]?.id]?.attributes || null
          }

          return {
            id: attributes.id,
            title: attributes.title,
            slug: attributes.slug,
            originalCurrency: attributes.original_currency,
            regularPrice: attributes.regular_price,
            salePrice: attributes.sale_price,
            dropshipPrice: attributes.reseller_price,
            quantity: attributes.quantity,
            quantityUnit: attributes.quantity_unit,
            supplier: getSupplier(),
            warehouse: getWarehouse(),
            countryId: attributes.country_id,
            provinceId: attributes.province_id,
            cityId: attributes.city_id,
            districtId: attributes.district_id,
            sku: attributes.sku,
            aliSku: attributes.ali_sku,
          }
        })

        setProductList(remap)
        setTotalProduct(countData)
      } else {
        setProductList([])
        setTotalProduct(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const actions = {
    edit: (val) => {
      console.log('edit', val)
      setDetailData(val)
      open()
    },
    delete: (val) => {
      console.log('delete', val)
      modalDeleteData('Product', val.id, val.title, deleteProduct, getList)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const goToSubProduct = (subProductId) => {
    // navigate(`/product/${subProductId}`, { replace: false })
    window.location.href = `/product/${subProductId}`
  }

  const handleSyncPricing = async (productId) => {
    loadingNotification('sync-pricing', 'Sync Product', 'Please wait while we Sync the product...')  
    try {
      const response = await syncPricingSubProduct(productId)
      if (response.success) {
        completedLoadingNotification('sync-pricing', 'Sync Product', 'The product has been Sync successfully.')
        getList()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      failedLoadingNotification('sync-pricing', 'Failed to Sync Pricing Product', `${errorMessage ? errorMessage : 'There was an error cloning the product. Please try again.'}`)
    }
  }
  const handleSyncGeneral = async (productId) => {
    loadingNotification('sync-general', 'Sync Product', 'Please wait while we Sync the product...')  
    try {
      const response = await syncGeneralSubProduct(productId)
      if (response.success) {
        completedLoadingNotification('sync-general', 'Sync Product', 'The product has been Sync successfully.')
        getList()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      failedLoadingNotification('sync-general', 'Failed to Sync General Product', `${errorMessage ? errorMessage : 'There was an error cloning the product. Please try again.'}`)
    }
  }

  useEffect(() => {
    getList()
    // eslint-disable-next-line
  }, [paramsProduct])

  const topSection = () => {
    return (
      <Flex justify='space-between' align='center'>
        <Text fw={500}>
          Sub-distributor Products
        </Text>

        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Button size='xs' variant="filled">Sync Data to Sub-Products</Button>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              fw='600'
              fz={12}
              leftSection={<IconRefresh size={14} />}
              onClick={() => handleSyncPricing(productId)}
            >
              Sync Pricing Data
            </Menu.Item>
            <Menu.Item
              fw='600'
              fz={12}
              leftSection={<IconRefresh size={14} />}
              onClick={() => handleSyncGeneral(productId)}
            >
              Sync General Data
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Flex>
    )
  }

  const renderList = (productList) => {
    if (productList.length > 0) {
      return (
        <Box>
          <TableProductBranch label={labelTable} data={productList} actionMethod={handleAction} />
          <Flex justify='end' mt={'xs'}>
            <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalProduct / paramsProduct['page[limit]']) || 0} />
          </Flex>
        </Box>
      )
    }
    else {
      return <NoData />
    }
  }

  const renderDrawerTitle = (detailData) => {
    return (
      <Group>
        <Text fw={500}>
          Edit Sub-product
        </Text>

        <Text c={'blue'} style={{ cursor: 'pointer'}} onClick={() => goToSubProduct(detailData?.id)}>
          {detailData?.id} <span><IconExternalLink size={13} /></span>
        </Text>
      </Group>
    )
  }

  return (
    <Box mb={20} mt={10}>
      <Paper my={'lg'} p={'md'} withBorder shadow="xs" radius="md">
        {topSection()}

        <Divider my={10} />
        <Box my={10}>
          {loading ? <LoadingData /> : renderList(productList)}
        </Box>
      </Paper>


      <Drawer opened={opened} position="right" onClose={close} title={renderDrawerTitle(detailData)}>
        {/* Drawer content */}
        <FormSubProduct dataSubProduct={detailData} onCloseModal={close} reloadList={() => getList()} />
      </Drawer>
    </Box>
  )
}

export default ProductBranch